export default __webpack_public_path__ + "static/cisco-a02f64a08207f3ad359fbbf0db52346c.jpg";